module.exports = __webpack_public_path__ + "img/amex.5cf23a50.png";